module.exports = __webpack_public_path__ + "img/venuetwo-resulttitle.7dfefc59.png";